(function() {
  'use strict';

  class QuickAddButton {
    constructor(el) {
      this.el = el;
      this.wrapper = el.closest('.quick-add-button-wrapper');
      this.variantId = this.wrapper?.dataset.variantId || this.wrapper?.dataset.variantid;
      this.form = this.wrapper?.querySelector('[data-product-form]') || this.wrapper?.closest('[data-product-form]');

      this.circle = el.querySelector('[data-quick-add-circle]');
      this.counter = el.querySelector('[data-quick-add-counter]');
      this.num = el.querySelector('[data-quick-add-count]');
      this.minus = el.querySelector('[data-quick-add-minus]');
      this.plus = el.querySelector('[data-quick-add-plus]');
      
      this.loader = null;
      if (this.num) {
        this.loader = document.createElement('span');
        this.loader.className = 'quick-add-button__loader';
        this.loader.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="38" stroke-dashoffset="9" opacity="0.7"><animateTransform attributeName="transform" type="rotate" values="0 7 7;360 7 7" dur="0.8s" repeatCount="indefinite"/></circle></svg>';
        this.loader.style.display = 'none';
        this.loader.style.visibility = 'hidden';
        if (this.num.nextSibling) {
          this.num.parentNode.insertBefore(this.loader, this.num.nextSibling);
        } else {
          this.num.parentNode.appendChild(this.loader);
        }
      }

      this.circleLoader = null;
      if (this.circle) {
        this.circleLoader = document.createElement('span');
        this.circleLoader.className = 'quick-add-button__circle-loader';
        this.circleLoader.innerHTML = '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="57" stroke-dashoffset="14" opacity="0.7"><animateTransform attributeName="transform" type="rotate" values="0 11 11;360 11 11" dur="0.8s" repeatCount="indefinite"/></circle></svg>';
        this.circleLoader.style.display = 'none';
        this.circleLoader.style.visibility = 'hidden';
        this.circle.appendChild(this.circleLoader);
      }

      this.count = 0;
      this.processing = false;
      this.synced = false;

      this.init();
    }

    init() {
      if (!this.variantId) {
        return;
      }

      if (!this.circle && !this.plus && !this.minus) {
        setTimeout(() => {
          this.circle = this.el.querySelector('[data-quick-add-circle]');
          this.plus = this.el.querySelector('[data-quick-add-plus]');
          this.minus = this.el.querySelector('[data-quick-add-minus]');
          if (this.circle || this.plus || this.minus) {
            this.init();
          }
        }, 100);
        return;
      }

      this.sync();

      if (this.circle) {
        this.circle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.processing) return;
        
        if (this.count > 0) {
          return;
        }
        
        if (this.form && this.variantId) {
          this.changeQuantity(1);
        } else if (this.form) {
          const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
          this.form.dispatchEvent(submitEvent);
        } else {
          this.changeQuantity(1);
        }
        });
      }

      if (this.plus) {
        // Удаляем старый обработчик, если он был
        if (this._plusHandler) {
          this.plus.removeEventListener('click', this._plusHandler, true);
          this.plus.removeEventListener('click', this._plusHandler, false);
        }
        
        // Убеждаемся, что кнопка кликабельна
        this.plus.style.pointerEvents = 'auto';
        this.plus.style.position = 'relative';
        this.plus.style.zIndex = '10';
        
        this._plusHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          if (this.processing) {
            return false;
          }
          this.changeQuantity(1);
          return false;
        };
        
        // Привязываем обработчик в фазе захвата для максимального приоритета
        this.plus.addEventListener('click', this._plusHandler, true);
        // Также привязываем в фазе всплытия на случай проблем с capture
        this.plus.addEventListener('click', this._plusHandler, false);
        
        // Дополнительно блокируем отправку формы, если кнопка внутри формы
        if (this.form) {
          const formSubmitHandler = (e) => {
            if (e.submitter === this.plus || (e.target && e.target.contains(this.plus))) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          };
          this.form.addEventListener('submit', formSubmitHandler, true);
          this._formSubmitHandler = formSubmitHandler;
        }
      }

      if (this.minus) {
        // Удаляем старый обработчик, если он был
        if (this._minusHandler) {
          this.minus.removeEventListener('click', this._minusHandler, true);
        }
        
        this._minusHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          if (this.processing || this.count <= 0) {
            return false;
          }
          this.changeQuantity(-1);
          return false;
        };
        
        this.minus.addEventListener('click', this._minusHandler, true);
      }

      const cartUpdateHandler = (event) => {
        if (event.detail?.isInitialLoad) {
          this.sync(event.detail?.cart);
          return;
        }
        
        if (event.detail?.variantId) {
          const eventVariantId = String(event.detail.variantId);
          const thisVariantId = String(this.variantId);
          if (eventVariantId !== thisVariantId) {
            return;
          }
        }
        
        if (this.processing) {
          return;
        }
        
        const cart = event.detail?.cart || event.detail;
        if (cart) {
          this.updateCount(cart);
        }
      };
      document.addEventListener('cart:updated', cartUpdateHandler);
      
      this._cartUpdateHandler = cartUpdateHandler;
    }

    async changeQuantity(delta) {
      if (this.processing) {
        return;
      }
      this.processing = true;

      const currentCount = this.count;
      const newCount = Math.max(0, currentCount + delta);

      if (this.plus) this.plus.disabled = true;
      if (this.minus) this.minus.disabled = true;
      this.el.classList.add('is-loading');
      
      if (this.count === 0 && this.circle) {
        this.showCircleLoader();
      } else {
        this.showLoader();
      }

      try {
        let response;
        
        if (newCount === 0) {
          const cart = await (window.getCart ? window.getCart() : fetch('/cart.js').then(r => r.json()));
          const item = cart.items.find(i => i.variant_id == this.variantId);
          if (item) {
            const formData = new FormData();
            formData.append('id', item.key);
            formData.append('quantity', '0');
            response = await fetch('/cart/change.js', {
              method: 'POST',
              body: formData
            });
            
            if (!response.ok) {
              throw new Error(`Failed to remove item: ${response.status}`);
            }
          }
        } else if (currentCount === 0) {
          const formData = new FormData();
          formData.append('id', String(this.variantId));
          formData.append('quantity', String(newCount));
          response = await fetch('/cart/add.js', { 
            method: 'POST', 
            body: formData 
          });
          
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to add item: ${response.status} - ${errorText}`);
          }
          
          const addResponse = await response.json().catch(() => null);
          if (addResponse && addResponse.items) {
            const item = addResponse.items.find(i => i.variant_id == this.variantId);
            if (item) {
              this.count = item.quantity;
              this.hideLoader();
              this.hideCircleLoader();
              this.updateUI();
              
              if (window.showProductAddNotification) {
                window.showProductAddNotification(item);
              }
              
              const cartUpdateEvent = new CustomEvent('cart:updated', {
                bubbles: true,
                cancelable: false,
                detail: {
                  cart: addResponse,
                  item_count: addResponse.item_count || 0,
                  items: addResponse.items || [],
                  wasJustAdded: true,
                  variantId: String(this.variantId)
                }
              });
              document.dispatchEvent(cartUpdateEvent);
              
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  cart: addResponse,
                  item_count: addResponse.item_count || 0,
                  data: { itemCount: addResponse.item_count || 0 }
                }
              }));
              document.dispatchEvent(new CustomEvent('shopify:cart:update', {
                bubbles: true,
                detail: {
                  cart: addResponse,
                  item_count: addResponse.item_count || 0
                }
              }));
              
              setTimeout(() => {
                this.processing = false;
                if (this.plus) this.plus.disabled = false;
                if (this.minus) this.minus.disabled = false;
                this.el.classList.remove('is-loading');
              }, 200);
              return;
            }
          }
        } else {
          const cart = await (window.getCart ? window.getCart() : fetch('/cart.js').then(r => r.json()));
          const item = cart.items.find(i => i.variant_id == this.variantId);
          if (item) {
            const formData = new FormData();
            formData.append('id', item.key);
            formData.append('quantity', String(newCount));
            response = await fetch('/cart/change.js', {
              method: 'POST',
              body: formData
            });
            
            if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`Failed to change quantity: ${response.status} - ${errorText}`);
            }
          } else {
            throw new Error('Item not found in cart');
          }
        }

        // Инвалидируем кеш перед получением обновленной корзины
        if (window.cartCache) {
          window.cartCache.invalidate();
        }
        const updatedCart = await (window.getCart ? window.getCart() : fetch('/cart.js').then(r => {
          if (!r.ok) {
            throw new Error(`Failed to fetch cart: ${r.status}`);
          }
          return r.json();
        }));
        
        const item = updatedCart.items.find(i => i.variant_id == this.variantId);
        const newItemCount = item ? item.quantity : 0;
        
        this.count = newItemCount;
        this.hideLoader();
        this.hideCircleLoader();
        this.updateUI();
        
        if (currentCount === 0 && newItemCount > 0 && item && window.showProductAddNotification) {
          window.showProductAddNotification(item);
        }
        
        const cartUpdateEvent = new CustomEvent('cart:updated', {
          bubbles: true,
          cancelable: false,
          detail: {
            cart: updatedCart,
            item_count: updatedCart.item_count || 0,
            items: updatedCart.items || [],
            wasJustAdded: true,
            variantId: String(this.variantId)
          }
        });
        document.dispatchEvent(cartUpdateEvent);
        
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            cart: updatedCart,
            item_count: updatedCart.item_count || 0,
            data: { itemCount: updatedCart.item_count || 0 }
          }
        }));
        document.dispatchEvent(new CustomEvent('shopify:cart:update', {
          bubbles: true,
          detail: {
            cart: updatedCart,
            item_count: updatedCart.item_count || 0
          }
        }));

      } catch (error) {
        this.hideLoader();
        this.hideCircleLoader();
      } finally {
        setTimeout(() => {
          this.processing = false;
          if (this.plus) this.plus.disabled = false;
          if (this.minus) this.minus.disabled = false;
          this.el.classList.remove('is-loading');
          this.hideCircleLoader();
        }, 200);
      }
    }

    sync(cart = null) {
      if (this.processing) {
        return;
      }

      if (!cart) {
        (window.getCart ? window.getCart() : fetch('/cart.js').then(r => r.json()))
          .then(cartData => {
            if (!this.processing) {
              this.updateCount(cartData);
              this.synced = true;
            }
          })
          .catch(() => {
            this.synced = true;
          });
        return;
      }

      if (!this.processing) {
        this.updateCount(cart);
        this.synced = true;
      }
    }

    updateCount(cart) {
      if (!cart) {
        this.count = 0;
        this.updateUI();
        this.synced = true;
        return;
      }

      if (!cart.items || !Array.isArray(cart.items)) {
        this.count = 0;
        this.updateUI();
        this.synced = true;
        return;
      }

      const item = cart.items.find(i => {
        const itemVariantId = typeof i.variant_id === 'string' ? parseInt(i.variant_id, 10) : i.variant_id;
        const thisVariantId = typeof this.variantId === 'string' ? parseInt(this.variantId, 10) : this.variantId;
        return itemVariantId === thisVariantId || i.variant_id == this.variantId;
      });
      
      const newCount = item ? item.quantity : 0;

      if (this.count !== newCount) {
        this.count = newCount;
        this.updateUI();
      }
      this.synced = true;
    }

    showLoader() {
      if (this.num && this.loader) {
        const numRect = this.num.getBoundingClientRect();
        const numWidth = numRect.width || 14;
        const numHeight = numRect.height || 24;
        
        this.loader.style.width = numWidth + 'px';
        this.loader.style.height = numHeight + 'px';
        this.loader.style.minWidth = numWidth + 'px';
        
        this.num.style.visibility = 'hidden';
        this.num.style.position = 'absolute';
        this.loader.style.display = 'inline-flex';
        this.loader.style.visibility = 'visible';
      }
    }
    
    hideLoader() {
      if (this.num && this.loader) {
        this.loader.style.display = 'none';
        this.loader.style.visibility = 'hidden';
        this.num.style.visibility = 'visible';
        this.num.style.position = '';
      }
    }

    showCircleLoader() {
      if (this.circle && this.circleLoader) {
        const icon = this.circle.querySelector('img');
        if (icon) {
          icon.style.visibility = 'hidden';
          icon.style.position = 'absolute';
        }
        this.circleLoader.style.display = 'block';
        this.circleLoader.style.visibility = 'visible';
      }
    }

    hideCircleLoader() {
      if (this.circle && this.circleLoader) {
        this.circleLoader.style.display = 'none';
        this.circleLoader.style.visibility = 'hidden';
        const icon = this.circle.querySelector('img');
        if (icon) {
          icon.style.visibility = 'visible';
          icon.style.position = '';
        }
      }
    }
    
    updateUI() {
      this.hideLoader();
      this.hideCircleLoader();
      
      if (this.num) this.num.textContent = this.count;
      if (this.el) {
        this.el.classList.toggle('is-expanded', this.count > 0);
      }
      if (this.counter) {
        this.counter.classList.toggle('is-visible', this.count > 0);
      }
    }
  }

  function clearAllInstances() {
    // Очищаем все старые инстансы
    const buttons = document.querySelectorAll('[data-quick-add-button]');
    buttons.forEach((button) => {
      const buttonEl = /** @type {HTMLElement & { _qa?: QuickAddButton }} */ (button);
      if (buttonEl._qa) {
        buttonEl._qa = undefined;
      }
    });
  }

  function initButtons(forceReinit = false) {
    const buttons = document.querySelectorAll('[data-quick-add-button]');
    buttons.forEach((button) => {
      try {
        const wrapper = button.closest('.quick-add-button-wrapper');
        if (!wrapper) return;
        
        const variantId = wrapper.dataset.variantId || wrapper.dataset.variantid;
        if (!variantId) return;
        
        const buttonEl = /** @type {HTMLElement & { _qa?: QuickAddButton }} */ (button);
        
        // Если forceReinit = true, всегда очищаем и переинициализируем
        if (forceReinit && buttonEl._qa) {
          buttonEl._qa = undefined;
        }
        
        // Если инстанс уже есть и не forceReinit, проверяем что он валидный
        if (!forceReinit && buttonEl._qa) {
          // Проверяем что элементы все еще на месте и привязаны к DOM
          const circle = buttonEl.querySelector('[data-quick-add-circle]');
          const plus = buttonEl.querySelector('[data-quick-add-plus]');
          const minus = buttonEl.querySelector('[data-quick-add-minus]');
          
          if (circle && plus && minus && 
              buttonEl._qa.circle === circle && 
              buttonEl._qa.plus === plus && 
              buttonEl._qa.minus === minus &&
              document.contains(buttonEl)) {
            return; // Инстанс валидный, пропускаем
          } else {
            buttonEl._qa = undefined; // Элементы изменились, очищаем
          }
        }
        
        const instance = new QuickAddButton(button);
        if (instance.variantId && (instance.circle || instance.plus || instance.minus)) {
          buttonEl._qa = instance;
        }
      } catch (error) {
        // Очищаем инстанс при ошибке
        const buttonEl = /** @type {HTMLElement & { _qa?: QuickAddButton }} */ (button);
        if (buttonEl._qa) {
          buttonEl._qa = undefined;
        }
      }
    });
  }

  function safeInit() {
    if (document.body) {
      initButtons();
      requestAnimationFrame(() => {
        initButtons();
        setTimeout(initButtons, 50);
        setTimeout(initButtons, 200);
        setTimeout(initButtons, 500);
      });
    } else {
      setTimeout(safeInit, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    if (document.body) {
      safeInit();
    } else {
      setTimeout(safeInit, 0);
    }
  }

  window.addEventListener('load', () => {
    setTimeout(initButtons, 0);
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => initButtons(true), 0);
  });
  
  document.addEventListener('filter:update', () => {
    // При обновлении фильтров очищаем все инстансы и переинициализируем
    clearAllInstances();
    
    // Даем DOM время обновиться, затем переинициализируем
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initButtons(true);
        setTimeout(() => initButtons(true), 100);
        setTimeout(() => initButtons(true), 300);
      });
    });
  });
  
  // Также слушаем события view transition (если используется)
  document.addEventListener('view-transition-end', () => {
    setTimeout(() => initButtons(true), 100);
  });

  let observerTimeout;
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const element = /** @type {Element} */ (node);
          if (element.matches && element.matches('[data-quick-add-button]')) {
            shouldInit = true;
          } else if (element.querySelector && element.querySelector('[data-quick-add-button]')) {
            shouldInit = true;
          }
        }
      });
    });
    if (shouldInit) {
      // Используем debounce для избежания множественных вызовов
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(initButtons, 100);
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

})();

